import { render, staticRenderFns } from "./ModalPrintMagazine.vue?vue&type=template&id=354f7e65&scoped=true&"
import script from "./ModalPrintMagazine.vue?vue&type=script&lang=js&"
export * from "./ModalPrintMagazine.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrintMagazine.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalPrintMagazine.vue?vue&type=style&index=1&id=354f7e65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f7e65",
  null
  
)

export default component.exports